{
  "copyright": "© {{year}} {{brand}}. All rights reserved.",
  "home": {
    "title": "Welcome to {{brand}}",
    "subtitle": "Select your platform to continue",
    "gridLabel": "{{brand}} selection",
    "b2b": {
      "description": "Access the comprehensive {{brand}} platform with AI matchmaking, market intelligence, compliance tools, and more.",
      "features": {
        "matchmaking": "AI-powered matchmaking engine",
        "products": "Product & service management",
        "trust": "Trust & compliance center",
        "market": "Market intelligence dashboard"
      },
      "cta": "Access {{brand}}"
    },
    "moderator": {
      "title": "Moderator Platform",
      "description": "Administrative access for platform moderators to manage deals, vet companies, and oversee operations.",
      "features": {
        "deals": "Deal assignment & management",
        "vetting": "Company vetting & tagging",
        "communication": "Communication hub",
        "leads": "Lead conversion tools"
      },
      "cta": "Access Moderator Platform"
    }
  },
  "header": {
    "home": "Home",
    "notifications": "Notifications",
    "loadingNotifications": "Loading notifications...",
    "noNotifications": "No notifications"
  }
}
